var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.offer.location.hub)?_c('div',[_c('paper-bid-edit',{attrs:{"form":_vm.form,"active-futures":_vm.activeFutures,"trade":_vm.trade}})],1):_c('div',[_c('bid-edit-step-1',{attrs:{"form":_vm.form,"reference":_vm.offer,"trade":_vm.trade,"active-futures":_vm.activeFutures,"other-errors":_vm.otherErrors,"show-reference":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }